import ApiBase from '../../ApiBase';

class Record extends ApiBase {
    route = '/cms/elements/records';

    /**
     * @method storeRecord
     * @param {object} data
     * @param {object} fields
     * @return {Promise<*>}
     */
    storeRecord = async (data, fields) => {
        data = await this.uploadRecordFields(data, fields);
        return this.post(this.route, data);
    }

    /**
     * @method updateRecord
     * @param {string} id
     * @param {object} data
     * @param {object} fields
     * @return {Promise<*>}
     */
    updateRecord = async (id, data, fields) => {
        data = await this.uploadRecordFields(data, fields);
        return this.patch(this.route + '/' + id, data);
    }

    //get speaker
    getSpeaker = async (id) => {
        return this.get('/agenda/speakers/' + id);
    }

    /**
     * @method uploadRecordFields
     * @param {object} data
     * @param {object} fields
     * @return {object}
     */
    uploadRecordFields = async (data, fields) => {
        for (var key in fields) {
            // skip loop if the property is from prototype
            // https://stackoverflow.com/questions/921789/how-to-loop-through-a-plain-javascript-object-with-the-objects-as-members
            if (!fields.hasOwnProperty(key)) continue;

            let type = fields[key].type;
            let identifier = fields[key].identifier;

            if (!data[identifier]) continue;

            if (type === 'date' || type === 'time') {
                let value = data[identifier];

                // Date object.
                if (typeof value === '[object Date]' || Object.prototype.toString.call(value) === '[object Date]') {
                    var iso_string = value.toISOString();
                }

                // Date serialized.
                if (value?.iso_string) {
                    var iso_string = value.iso_string;
                }

                if (type === 'date') {
                    data[identifier] = iso_string.split('T')[0];
                }
                else if (type === 'time') {
                    data[identifier] = iso_string.split('T')[1].split('.')[0];
                }
            }
        }

        return data;
    }
}

export default new Record();
